import { useState } from "react";
import { ChevronLeft, ChevronRight, FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const fmtWIB = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { timeZone: "Asia/Jakarta" }) : "—");
export const cleanParams = (f) => Object.fromEntries(Object.entries(f).filter(([, v]) => v !== "" && v != null));

export const FilterSelect = ({ label, value, onChange, options, testid }) => (
  <label className="block min-w-[140px]">
    <span className="mb-1 block text-[10px] font-semibold uppercase tracking-widest text-zinc-500">{label}</span>
    <select value={value} onChange={(e) => onChange(e.target.value)} className="rk-input !py-2 text-sm" data-testid={testid}>
      <option value="">Semua</option>
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  </label>
);

export const FilterInput = ({ label, testid, ...props }) => (
  <label className="block min-w-[140px]">
    <span className="mb-1 block text-[10px] font-semibold uppercase tracking-widest text-zinc-500">{label}</span>
    <input {...props} className="rk-input !py-2 text-sm [color-scheme:dark]" data-testid={testid} />
  </label>
);

export const Pager = ({ page, pages, total, onPage }) => (
  <div className="mt-4 flex items-center justify-between text-xs text-zinc-400" data-testid="pager">
    <span data-testid="pager-info">Halaman {page} dari {pages} · {total.toLocaleString("id-ID")} data</span>
    <div className="flex gap-2">
      <button disabled={page <= 1} onClick={() => onPage(page - 1)} className="rk-btn-ghost inline-flex items-center gap-1 !px-3 !py-1.5 disabled:opacity-40" data-testid="pager-prev">
        <ChevronLeft size={14} /> Sebelumnya
      </button>
      <button disabled={page >= pages} onClick={() => onPage(page + 1)} className="rk-btn-ghost inline-flex items-center gap-1 !px-3 !py-1.5 disabled:opacity-40" data-testid="pager-next">
        Berikutnya <ChevronRight size={14} />
      </button>
    </div>
  </div>
);

export const ExportButton = ({ url, params, testid }) => {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      const res = await api.get(url, { params, responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || "export.xlsx";
      const href = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = href;
      a.download = name;
      a.click();
      URL.revokeObjectURL(href);
      toast.success("File Excel berhasil diunduh");
      if (res.headers["x-export-truncated"] === "1") toast.warning("Data terlalu banyak: hanya 50.000 baris terbaru yang diexport. Persempit filter tanggal.");
    } catch (e) {
      toast.error(errMsg(e, "Export gagal"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <button onClick={run} disabled={busy} className="rk-btn-primary inline-flex items-center gap-2 !py-2 text-sm" data-testid={testid}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : <FileSpreadsheet size={14} />} Export Excel
    </button>
  );
};
